import DashboardLayout from "./DashboardLayout";
import { FaDownload } from "react-icons/fa";
import { FaGlobe } from "react-icons/fa";

export default function Brochure() {
  return (
    <DashboardLayout
      brochure="Integrated Brochure & Syllabus System (IBASS)"
      childTab={11}
      animated={true}
    >
      <div className="max-w-md mx-auto bg-white p-6 rounded-lg shadow space-y-5 mt-20">
        <div className="bg-blue-100 text-blue-700 p-3 rounded flex  text-center font-semibold">
          PLEASE SELECT AN OPTION BELOW TO CONTINUE.
        </div>

        <button
          onClick={() => {
            window.location.href = "/e-syllabus";
          }}
          className="w-full bg-green-700 text-white py-3 rounded flex items-center justify-center gap-2 mb-4"
        >
          <FaDownload />
          Continue to Downloads
        </button>

        <button
          onClick={() => {
            window.location.href = "/brochure-by-programme";
          }}
          className="w-full bg-blue-600 text-white py-3 rounded flex items-center justify-center gap-2"
        >
          <FaGlobe />
          Continue Online
        </button>
      </div>
    </DashboardLayout>
  );
}
